module.exports = __webpack_public_path__ + "img/dxrx-logo--dark.ac04e1d9.svg";